import React, { FC, Suspense, useEffect } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { DataLoader } from './ConfirmDataLoader'
import { TerminateContractErrorHandler } from '../TerminateContractErrorHandler'
import { ContractTerminationRequestPreview } from './ContractTerminationRequestPreview'
import { ConfirmContractTerminationForm } from './ConfirmForm'
import { ConfirmSuccess } from './Success'
import { resolveContractTerminationTerminology } from '../utils/resolveContractTerminationTerminology'

import { View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const ConfirmContractTermination: FC = () => {
  const { t } = useTranslation(['common', 'terminateContract', 'titles'])
  const [view, setView] = React.useState<'default' | 'success'>('default')
  const [params] = useSearchParams()
  const { frontPagePath } = useContractPaths()

  useEffect(() => {
    if (params.get('success')) {
      setView('success')
    }
  }, [params, setView])

  return (
    <TitleController title={t('terminateContract:headings.confirmation')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>
            {t('terminateContract:headings.confirmation')}
          </View.HeaderTitle>
        </View.Header>
        <View.Sidebar />
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <TerminateContractErrorHandler view="confirm">
              <DataLoader>
                {(data) => (
                  <>
                    {view === 'success' && (
                      <ConfirmSuccess
                        contractType={data.contract.contractType}
                      />
                    )}
                    {view === 'default' && (
                      <ConfirmContractTerminationForm
                        contractTerminationRequestId={
                          data.contractTerminationRequest.id
                        }
                        contractType={data.contract.contractType}
                        userMetadata={data.userMetadata}
                      >
                        <ContractTerminationRequestPreview
                          contractTerminationRequest={
                            data.contractTerminationRequest
                          }
                          tenants={data.tenants}
                          contract={data.contract}
                          confirmButtonLabel={t(
                            resolveContractTerminationTerminology(
                              data.contract.contractType
                            ).confirmButton
                          )}
                        />
                      </ConfirmContractTerminationForm>
                    )}
                  </>
                )}
              </DataLoader>
            </TerminateContractErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
